export function RankingCommonEchartOp ({
  v
}) {
  let option = {
    color: [
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 1,
          color: 'rgba(65, 45, 208, 1)' // 0% 处的颜色
        }, {
          offset: 0,
          color: 'rgba(43, 214, 249, 1)' // 100% 处的颜色
        }]
      }
    ],
    grid: {
      left: '0%',
      top: '5%',
      right: '0%',
      bottom: '-20%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      data: ['投屏', '家庭看护', '视频通话', '影视', '遥控', '影视', '遥控'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: [{
      data: [120, 200, 150, 80, 70, 110, 130],
      type: 'bar',
      showBackground: true,
      barCategoryGap: 10,
      barWidth: 10,
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)'
      }
    }]
  }

  return option
}
